<template>
  <div id="cost-custom-config-modal" class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main" >
      <div class="title-area" id="modal-moving">
        <h2>価格カスタム設定</h2>
      </div>
      <div class="data-area">
        <div class="error_message">{{ errorMessage.text }}</div>
        <ul>
          <li v-for="(num,index) in 5" :key="index">
            <span class="label">価格項目名{{ num }}</span>
            <input type="text" v-model="customNameGroup[num]">
          </li>
        </ul>
      </div>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['costCustomName1'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['costCustomName2'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['costCustomName3'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['costCustomName4'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['costCustomName5'] }}</p>
      <div class="button-area">
        <button type="button" class="main_btn" @click="updateCostCustom">OK</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as AppUtil from '../../utils/App'
import {API_URL} from '../../constants/App'
export default {
  name: 'CostCustomConfigModal',
  props: {
    prevDialog: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** カスタム名グループ */
      customNameGroup: {1: '', 2: '', 3: '', 4: '', 5: ''},
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.modalShown = false
      this.prevDialog()
    },
    /** カスタム名の取得 */
    getCostCustom: function () {
      axios.get(API_URL.ADMIN + '/get-cost-custom'
      ).then(response => {
        let data = response.data.data
        this.customNameGroup[1] = data.costCustomName1
        this.customNameGroup[2] = data.costCustomName2
        this.customNameGroup[3] = data.costCustomName3
        this.customNameGroup[4] = data.costCustomName4
        this.customNameGroup[5] = data.costCustomName5
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** カスタム名の更新 */
    updateCostCustom: function () {
      let payload = {
        costCustomName1: this.customNameGroup[1],
        costCustomName2: this.customNameGroup[2],
        costCustomName3: this.customNameGroup[3],
        costCustomName4: this.customNameGroup[4],
        costCustomName5: this.customNameGroup[5]
      }
      axios.post(API_URL.ADMIN + '/update-cost-custom', payload
      ).then(responce => {
        let modalData = {
          messages: ['変更しました'],
          onOk: () => {
            this.modalShown = false
            this.prevDialog()
          }
        }
        this.errorMessage = {}
        this.validateErrorMessages = {}
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    }
  },
  created: function () {
    this.getCostCustom()
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 18px;
  .label{
    min-width: 110px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/CostCustomConfigModal.vue